import bikeScene from "./bike.js";
import { faqAnim } from "./faq.js";
import { mapSection } from "./map.js";
import BadgerAccordion from "badger-accordion";
import { cookie } from "./cookiebanner";

if (module.hot) {
  module.hot.accept();
}

// Bike-animation
bikeScene();

// Mapbox
mapSection;

// Cookie-banner
cookie;

// Creating a new instance of the accordion
const accordionDomNode = document.querySelector(".js-badger-accordion");

const accordion = new BadgerAccordion(accordionDomNode, {
  openMultiplePanels: true
});
setTimeout(() => {
  accordion.calculateAllPanelsHeight();
}, 200);

// Cross animation on click
[...document.querySelectorAll(".js-badger-accordion-header")].forEach(item => {
  const box = item.querySelector(".cross");

  const anim = faqAnim(box);

  item.addEventListener("click", event => {
    box.classList.toggle("open");

    if (box.classList.contains("open")) {
      anim.playSegments([1, 28], true);
    } else {
      anim.playSegments([28, 55]);
    }
  });
});
